import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';
import { push } from 'connected-react-router';

// Selectors
// @ts-ignore
import { makeSelectFinalFormUnsavedValuesExist } from 'services/finalFormsUnsavedValues/selectors';
// @ts-ignore
import { makeSelectTimesheetValue } from 'services/timesheets/selectors';

interface OwnProps {
    timesheetId?: number;
    namespace: string;
    children: React.ReactNode;
}

interface ConnectedProps {
    unsavedValuesExist: boolean;
    isApproved?: boolean;
}

interface DispatchProps {
    push: Function;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

export class TimesheetTableRowLink extends React.PureComponent<Props> {
    handleClick = () => {
        const { timesheetId } = this.props;
        this.props.push(`/organization/time/timesheets/${timesheetId}`);
    };

    render(): React.ReactElement {
        const { children, unsavedValuesExist, isApproved } = this.props;
        return (
            <Table.Row
                onClick={this.handleClick}
                error={!isApproved && unsavedValuesExist}
                // HACK: inline style
                style={{
                    cursor: 'pointer'
                }}
            >
                {children}
            </Table.Row>
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    unsavedValuesExist: makeSelectFinalFormUnsavedValuesExist(),
    isApproved: makeSelectTimesheetValue('isApproved')
});

export default connect<ConnectedProps, DispatchProps, OwnProps>(
    mapStateToProps,
    { push }
)(TimesheetTableRowLink);
